import { Observable } from "rxjs";

import { APP_ENV } from "config/globals";
import { st, AppSettings, ApiService } from "lib/index";

import {
  INITIALIZE_APP,
  FETCH_APP,
  FETCH_APP_START,
  FETCH_APP_SUCCESS,
  FETCH_APP_FAILURE,
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_START,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  SET_APP_ERROR,
  CREATE_ALERT,
  REMOVE_ALERT,
  TOGGLE_LEFT_BAR,
  TOGGLE_SIDEBAR,
  FORCE_LEFT_BAR_TOGGLE,
  SET_LOCATION,
  initializeApp,
  fetchApp,
  setAppError,
  createAlert,
  removeAlert,
  toggleLeftBar,
  forceLeftBarToggle,
  setLocation,
  pushRoute,
  pushCompanyRoute,
  productsInstance,
} from "./actions";
export * from "./actions";

const LEFT_BAR_TOGGLED_CK = `socialtravel-partnerapp-${APP_ENV}/ui/leftBarToggled`;
const RECENT_API_VERSION_MET_CK = `st-partnerapp-${APP_ENV}/app/recentApiVersionMet`;

export const stateSelector = (state) => state.app;

const initialState = {
  initialized: false,
  alerts: [],
  fetchAppDone: false,
  fetchAppLoading: false,
  fetchAppFailed: false,
  leftBarToggled: true,
  leftBarToggleForced: null,
  leftBarExtended: true,
  sidebarVisible: true,
  location: null,
};

const reducers = {
  [INITIALIZE_APP]: (state, { reset }) =>
    reset
      ? {
          ...initialState,
          initialized: true,
        }
      : state,

  [SET_APP_ERROR]: (state, { error }) => {
    return {
      ...state,
      appError: error,
    };
  },

  [FETCH_APP_START]: (state) => ({
    ...state,
    fetchAppLoading: true,
    fetchAppFailed: false,
  }),

  [FETCH_APP_SUCCESS]: (state) => ({
    ...state,
    fetchAppLoading: false,
    fetchAppDone: true,
  }),

  [FETCH_APP_FAILURE]: (state) => ({
    ...state,
    fetchAppLoading: false,
    fetchAppFailed: true,
  }),

  [CREATE_ALERT]: (state, { alert }) => {
    return {
      ...state,
      alerts: state.alerts.filter((a) => a.uuid !== alert.uuid).concat([alert]),
    };
  },

  [REMOVE_ALERT]: (state, { alert }) => {
    return {
      ...state,
      alerts: state.alerts.filter((a) => a.uuid !== alert.uuid),
    };
  },

  [TOGGLE_LEFT_BAR]: (state, { toggle, persist }) => {
    const leftBarToggled = toggle === null || toggle === undefined ? !state.leftBarExtended : !!toggle;
    const { leftBarToggleForced } = state;

    return {
      ...state,
      leftBarToggled,
      leftBarExtended: leftBarToggleForced === null ? leftBarToggled : leftBarToggleForced,
    };
  },

  [TOGGLE_SIDEBAR]: (state) => {
    return {
      ...state,
      sidebarVisible: !state.sidebarVisible,
    };
  },

  [FORCE_LEFT_BAR_TOGGLE]: (state, { force: leftBarToggleForced }) => {
    const { leftBarToggled } = state;
    return {
      ...state,
      leftBarToggleForced,
      leftBarExtended: leftBarToggleForced === null ? leftBarToggled : leftBarToggleForced,
    };
  },

  [SET_LOCATION]: (state, { location }) => ({
    ...state,
    location,
  }),
};

const epics = [
  (actions$, { getState }) =>
    actions$.ofType(INITIALIZE_APP).flatMap(() => {
      return Observable.concat(
        Observable.of(toggleLeftBar(window.localStorage.getItem(LEFT_BAR_TOGGLED_CK) !== "false", false)),
        stateSelector(getState()).fetchAppDone ? Observable.empty() : Observable.of(fetchApp())
      );
    }),

  (actions$) =>
    actions$.ofType(FETCH_APP).flatMap(() => {
      return Observable.concat(
        Observable.of({ type: FETCH_APP_START }),
        AppSettings.fetch()
          .mapTo({ type: FETCH_APP_SUCCESS })
          .catch((e) => {
            return Observable.of({ type: FETCH_APP_FAILURE });
          })
      );
    }),

  (actions$) =>
    actions$.ofType(FETCH_APP_SUCCESS).flatMap(() => {
      if (AppSettings.recent_api_version > ApiService.apiVersion) {
        const recentApiVersionMet = +(window.localStorage.getItem(RECENT_API_VERSION_MET_CK) || ApiService.apiVersion);
        if (AppSettings.recent_api_version > recentApiVersionMet) {
          console.debug(
            `AppSettings.recent_api_version returned a new api version: ${AppSettings.recent_api_version}. Reloading the page!`
          );
          window.localStorage.setItem(RECENT_API_VERSION_MET_CK, AppSettings.recent_api_version.toString());
          window.location.reload();
        }
      }
      return Observable.empty();
    }),

  (actions$) =>
    actions$.ofType(CREATE_ALERT).flatMap(({ alert }) => {
      if (alert.timeout) {
        return Observable.of({ type: REMOVE_ALERT, alert }).delay(alert.timeout);
      } else {
        return Observable.empty();
      }
    }),

  (actions$, { getState }) =>
    actions$
      .ofType(TOGGLE_LEFT_BAR)
      .filter(({ persist }) => !!persist)
      .switchMap(() => {
        const { leftBarToggled } = stateSelector(getState());
        try {
          window.localStorage.setItem(LEFT_BAR_TOGGLED_CK, !!leftBarToggled);
        } catch (e) {
          if (__DEV__) {
            throw e;
          }
        }
        return Observable.empty();
      }),
];

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/app/index.js